import type { GameMeta } from "../../common/gameMeta.js";
import type { MirrorMirrorVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Mirror Mirror",
	minPlayers: 1,
	maxPlayers: 8,
	description: "Watch the pattern light up — then tap it in reverse!",
	instructions: `
1. Watch the tiles light up one by one
2. When REVERSE IT! appears, tap the tiles in reverse order
3. Faster answers earn a speed bonus
4. 5 rounds — highest score wins!
	`,
	mobileBrowserCompatible: true,
	modifiers: [
		{
			id: "hex",
			label: "Hex Tiles",
			instructions: "The tiles are hexagonal — same rules, different shape.",
			config: { shapeStyle: "hex" } satisfies MirrorMirrorVariantConfig,
		},
	],
} satisfies GameMeta;
